import { patterns } from '../settings';

export const isZip = (value: string) => patterns.ZIP_STRING.test(value);
